import facebookProduct from './facebookProduct'
import facebookUser from './facebookUser'

const facebookActions = {
  initialized: false,
  pixel: '573978643312720',
  async init() {
    if (!this.initialized){
      const user = await facebookUser()
      fbq('init', this.pixel, user)
      this.initialized = true
    }
  },
  async pageView() {
    await this.init()
    fbq('track', 'PageView')
  },
  async search(searchString = '', produtos = []) {
    if (!searchString) return
    await this.init()
    fbq('track', 'Search', {
      search_string: searchString,
      content_type: 'product',
      currency: 'BRL',
      contents: (produtos || []).map(produto => ({
        id: produto.id,
        item_price: produto?.skus[0]?.properties?.price,
      })),
    })
  },
  async viewContent(produto) {
    if (!produto) return
    await this.init()
    fbq('track', 'ViewContent', {
      content_type: 'product',
      currency: 'BRL',
      contents: facebookProduct([produto]),
    })
  },
  async addToCart(produtos){
    await this.init()
    fbq('track', 'AddToCart', {
      content_type: 'product',
      currency: 'BRL',
      contents: (produtos || []).map(produto => ({
        id: produto.id,
        quantity: produto.quantidade,
        item_price: produto?.anuncio?.preco?.por,
        name: produto?.variacao?.titulo
      })),
    });
  },
}

export default facebookActions
